export default __webpack_public_path__ + "static/media/protractor-blue.11289d8d.svg";